import api from "./api";

const ChatbotService = {
    list: async () => {
        const { data } = await api.get("/chatbots");
        return data;
    },

    create: async (data) => {
        const { data: result } = await api.post("/chatbots", data);
        return result;
    },

    update: async (chatbotId, data) => {
        const { data: result } = await api.put(`/chatbots/${chatbotId}`, data);
        return result;
    },

    delete: async (chatbotId) => {
        const { data } = await api.delete(`/chatbots/${chatbotId}`);
        return data;
    },
};

export default ChatbotService;
